import { render, staticRenderFns } from "./RecomSoldArticles.vue?vue&type=template&id=af09f620"
import script from "./RecomSoldArticles.vue?vue&type=script&lang=js"
export * from "./RecomSoldArticles.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports